import { UIBrandedFare, UIFetchStatus, UIClientFetchError } from "@flights/types";

export type BaseFareOfferToken = string;
export type BrandedFare = {
  baseOfferToken?: string;
  fetchStatus: UIFetchStatus;
  error?: UIClientFetchError;
  brandedFareOffers?: Array<UIBrandedFare>;
};

export type State = {
  fareOffersWithDetails: Record<BaseFareOfferToken, BrandedFare>;
  /* start - flights_apex_web_fetch_branded_fare_flight_details */
  selectedFareToken?: string;
  /* end - flights_apex_web_fetch_branded_fare_flight_details */
};

export const getInitialState = (): State => ({
  fareOffersWithDetails: {},
  /* start - flights_apex_web_fetch_branded_fare_flight_details */
  selectedFareToken: undefined
  /* end - flights_apex_web_fetch_branded_fare_flight_details */
});
